import React from 'react'
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table,
    Divider
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

    render() {
        const BankCustomerSearchData = this.props.BankCustomerSearchData;
        const BankCustomerData = this.props.BankCustomerData;

        return (
            <div style={{ padding: '5px' }}>
                <h2><center><u>{BankCustomerData[0].bankName}</u></center></h2>
                <h3><center>Bought Leaf Balance Payment Bank Customer List</center></h3>
                <div>&nbsp;</div>
                <h3><center>Factory: {BankCustomerSearchData.factoryName}</center></h3>
                <h3><center>Route: {BankCustomerSearchData.routeName === undefined ? 'All Route' : BankCustomerSearchData.routeName}</center></h3>
                <div>&nbsp;</div>
                <div>&nbsp;</div>
                <Divider />
                <div>
                    <Box minWidth={1050}>
                        <TableContainer>
                            <Table aria-label="caption table" size='small'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={'center'} style={{ fontSize: '16px', border: "1px solid #ccc" }}> Branch</TableCell>
                                        <TableCell align={'center'} style={{ fontSize: '16px', border: "1px solid #ccc" }}>Account Number</TableCell>
                                        <TableCell align={'center'} style={{ fontSize: '16px', border: "1px solid #ccc" }}>Name</TableCell>
                                        <TableCell align={'center'} style={{ fontSize: '16px', border: "1px solid #ccc" }}>Amount(Rs)</TableCell>
                                        <TableCell align={'center'} style={{ fontSize: '16px', border: "1px solid #ccc" }}>Remark</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {BankCustomerData.map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.branchName}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.accountNumber}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.name}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                {data.amount.toFixed(2)}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div >
                <div>&nbsp;</div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div >
        );
    } 
}
